import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { FormatoProductosService } from 'src/app/services/formato-productos.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarProductoComponent } from 'src/app/views/shared/modal-seleccionar-producto/modal-seleccionar-producto.component';
import { debounceTime, filter } from 'rxjs/operators';
import { NotaVentaService } from 'src/app/services/nota-venta.service';
import gql from 'graphql-tag';
import { ProductoService } from 'src/app/services/producto.service';
import { SaldoStockService } from 'src/app/services/saldo-stock.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { QueryResult } from 'src/app/shared/object/queryResult.model';
import { CabeceraNotaVentaComponent } from './../cabecera-nota-venta/cabecera-nota-venta.component';
import * as _ from 'lodash';
import { DocumentoService } from 'src/app/services/documento.service';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';

@Component({
  selector: 'app-detalle-nota-venta',
  templateUrl: './detalle-nota-venta.component.html',
  styleUrls: ['./detalle-nota-venta.component.scss'],
  providers: [SecurityService],
})
export class DetalleNotaVentaComponent implements OnInit {
  @Input() cabeceraComponent: CabeceraNotaVentaComponent;
  @Input() permiteUnidadNegocio: boolean = false;

  @Output() onAddProductoRequest: EventEmitter<void> = new EventEmitter<void>();
  @Output() onDeleteProductoRequest: EventEmitter<any> = new EventEmitter<any>();

  // Modales
  @ViewChild(ModalSeleccionarProductoComponent, { static: true }) modalSeleccionarProducto: ModalSeleccionarProductoComponent;
  @ViewChild(ModalConfirmComponent, { static: true }) modalConfirm: ModalConfirmComponent;

  // Form
  formDetails: FormGroup;

  // Data &  Tmp
  private rutEmpresa: Number;
  private sucursalEmpresa: Number;
  headerData: any = null; // Viene desde Cabecera
  productoSeleccionado: any = null;
  optionsFormato: Array<any> = [];
  currentProcess: any = null;
  totalesDocumento: any = null;
  inputLinea: number = 0;

  // Utils
  private log: any;
  mode: string = '';

  private getNombreBodegaSeleccionada(): string {
    try {
      const header = this.cabeceraComponent ? this.cabeceraComponent.getHeaderData() : null;
      const codigoBodega = header ? header.codigoBodega : null;
      const cabeceraAny: any = this.cabeceraComponent as any;
      const bodegas: any[] = cabeceraAny && cabeceraAny.optionsBodega ? cabeceraAny.optionsBodega : [];
      const bodega = bodegas && codigoBodega ? bodegas.find((b) => b.value === codigoBodega || b.codigo === codigoBodega) : null;
      return (bodega && (bodega.label || bodega.nombre)) ? (bodega.label || bodega.nombre) : (codigoBodega ? `${codigoBodega}` : '');
    } catch {
      return '';
    }
  }

  private esErrorSaldoInsuficiente(mensaje: any): boolean {
    const ctx = (mensaje && mensaje.contexto) ? String(mensaje.contexto) : '';
    const txt = (mensaje && mensaje.texto) ? String(mensaje.texto) : '';
    return ctx.includes('SaldoDisponible') || txt.toLowerCase().includes('cantidad disponible en bodega') || txt.toLowerCase().includes('saldo');
  }

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private clog: ConsoleService,
    private formatoProductoService: FormatoProductosService,
    private productoService: ProductoService,
    private saldoStockService: SaldoStockService,
    private notaVentaService: NotaVentaService,
    private toastService: ToastService,
    private messageRendererService: MessageRendererService,
    private documentoService: DocumentoService,
    private formValidatorsService: FormValidatorsService
  ) {
    this.log = this.clog.log('NOTA-VENTA-DETALLES');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());

    this.createForms();
    this.formChangesSubscriptions();
  }

  createForms() {
    this.formDetails = this.fb.group({
      codigoProducto: ['', [Validators.required]],
      formato: [null, [Validators.required]],
      cantidad: [null, [Validators.required, Validators.min(1)]],
      precioUnitario: [null, [Validators.required]],
      descuento: [null],
    });
  }

  resetFormDetails() {
    this.formDetails.reset();
    this.formDetails.markAsPristine();
    this.formDetails.markAsUntouched();
    this.formDetails.get('codigoProducto').setValue('');
    this.formDetails.get('formato').setValue(null);
    this.formDetails.get('cantidad').setValue(null);
    this.formDetails.get('precioUnitario').setValue(null);
    this.formDetails.get('descuento').setValue(null);

    this.modalSeleccionarProducto.clearLast();

    this.optionsFormato = [];
    this.productoSeleccionado = null;
  }

  formChangesSubscriptions() {
    // código de producto
    this.formDetails
      .get('codigoProducto')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((codigo: string) => {
        this.modalSeleccionarProducto.searchBySKU(codigo);
      });

    // formato
    this.formDetails.get('formato').valueChanges.subscribe((formato) => this.handleFormatoChange());
  }

  // Método consumido desde parent
  handleHeaderDataChange(headerData) {
    this.log('handleHeaderDataChange', headerData);
    this.headerData = headerData;
    this.getPrecioUnitario();
  }

  abrirModalSeleccionarProducto() {
    // this.modalSeleccionarProducto.show()
    if (!this.validateUnidadNegocioCabecera()) {
      this.showMessageSeleccionUnidadNegocio();
      return;
    }

    const { unidad_negocio_codigo } = this.cabeceraComponent.getHeaderData();
    this.modalSeleccionarProducto.showWithConfig({
      cleanData: true,
      showUnidadDeNegocioIfAllowed: true,
      defaultUnidadNegocio: unidad_negocio_codigo,
    });
  }

  //CARGAR DATOS DEL EDITAR NOTA VENTA
  Load(nv) {
    //SI EXISTE NOTA DE VENTA - MOSTRAR RESULTADO
    if (nv) {
      this.currentProcess = {
        documentTotal: nv.DocumentTotal,
        productDocument: nv.ProductDocument,
        proceso: nv.proceso,
        folio: nv.folio,
        cabecera: nv.cabecera,
      };
    }
  }

  getProducts({ inputParams: modalInputParams, callback }) {
    const self = this;

    const { unidad_negocio_codigo } = this.cabeceraComponent.getHeaderData();

    this.log(modalInputParams);
    const inputParams = {
      empresa_rut: modalInputParams.empresa_rut,
      sku: modalInputParams.sku,
      descripcion: modalInputParams.descripcion,
      tipobusquedad_afecto_exento: modalInputParams.tipobusquedad_afecto_exento,
      familia: modalInputParams.familia,
      rubro: modalInputParams.rubro,
      unidad_negocio_codigo: unidad_negocio_codigo,
      paginaActual: modalInputParams.paginaActual,
      cantidadRegistrosPorPagina: modalInputParams.cantidadRegistrosPorPagina,
      sucursal_codigo: modalInputParams.sucursal_codigo,
    };

    this.productoService.obtenerSegunFiltroProductosFacturables(modalInputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      if (!respuesta) {
        callback(new QueryResult(null, 0, 0, 0));
        return;
      }
      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
      callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros));
    });
  }

  getProductsByUnidadNegocio({ inputParams, callback }) {
    if (!inputParams.unidad_negocio_codigo) {
      const { unidad_negocio_codigo } = this.cabeceraComponent.getHeaderData();
      inputParams.unidad_negocio_codigo = unidad_negocio_codigo;
    }
    this.modalSeleccionarProducto.getProductsByUnidadNegocio({ inputParams, callback });
  }

  onProductoSeleccionado({ data: _productoSeleccionado, origen }) {
    this.productoSeleccionado = _productoSeleccionado;
    this.formDetails.get('codigoProducto').setValue(_productoSeleccionado.sku);
    this.formatoProductoService.GetFormatosByCodigo(this.rutEmpresa, this.productoSeleccionado.codigo, ({ mensajes, respuesta }) => {
      this.optionsFormato = respuesta.registros.map((formato) => ({ value: formato.formato_codigo, label: formato.formato_nombre, ...formato }));
      this.formValidatorsService.selectDefaultFormatoProducto(this.formDetails.get('formato'), this.optionsFormato);
    });
  }

  onProductoNoEncontrado() {
    this.resetFormDetails();
  }

  // limpiarDataProductoSeleccionado() {
  //   this.formDetails.get("productoExistente.cantidad").setValue(0)
  //   this.productoSeleccionado = null

  //   this.optionsFormato = []
  //   this.formDetails.get("formato").setValue(null)
  //   this.formDetails.get("precioUnitario").setValue(null)
  // }

  handleFormatoChange() {
    this.getPrecioUnitario();
  }

  getPrecioUnitario() {
    if (!this.headerData || !this.headerData.cliente || !this.productoSeleccionado || !this.formDetails.get('formato').value) return;

    this.log('getPrecioUnitario GO!');

    // Limpiar
    this.formDetails.get('precioUnitario').setValue(null);

    const formatoSeleccionado = this.formDetails.get('formato').value;
    const inputParams: any = {
      empresa_rut: this.rutEmpresa,
      producto_codigo: this.productoSeleccionado.codigo,
      formato_codigo: this.optionsFormato.filter((opt) => opt.value === formatoSeleccionado)[0].formato_codigo,
      lista_precio_codigo: this.headerData.cliente.lista_precio_codigo,
      tipo_producto_codigo: this.productoSeleccionado.tipo_producto_codigo,
    };

    this.productoService.GetPrecioUnitario(inputParams, ({ precio_unitario }) => {
      this.formDetails.get('precioUnitario').setValue(precio_unitario);
    });
  }

  agregarProducto() {
    const valido = this.formValidatorsService.validate(this.formDetails);
    if (!valido) return;

    const precioUnitario = this.formDetails.get('precioUnitario').value;
    if (precioUnitario === null || precioUnitario === undefined || Number(precioUnitario) === 0) {
      this.toastService.error('No está permitido agregar productos con precio 0.');
      return;
    }

    // Validar que no agregue 2 veces
    if (this.currentProcess && this.currentProcess.productDocument) {
      const { codigoProducto, formato } = this.formDetails.value;
      const _listaSimilares: Array<any> = this.currentProcess.productDocument.filter((prod) => prod.codigo === codigoProducto && prod.formato === formato);
      if (_listaSimilares && _listaSimilares.length > 0) {
        this.toastService.error('Producto ya se encuentra agregado');
        return;
      }

      if (this.formDetails.get('cantidad').value > 1 && this.formDetails.get('formato').value.includes('MED')) {
        this.toastService.error('La cantidad debe ser 1 cuando el formato es MED');
        return;
      }
    }

    // Validar saldo real en la bodega seleccionada (misma fuente que el modal de stock).
    if (this.productoSeleccionado && this.cabeceraComponent) {
      const header = this.cabeceraComponent.getHeaderData();
      const codigoBodega = header ? header.codigoBodega : null;
      const formatoCodigo = this.formDetails.get('formato').value;
      const cantidadSolicitadaRaw = Number(this.formDetails.get('cantidad').value);
      const cantidadSolicitada = Number.isFinite(cantidadSolicitadaRaw) ? cantidadSolicitadaRaw : 0;

      const self = this;
      const inputParamsStock = {
        entidad: {
          rut_empresa: Number(this.rutEmpresa),
          sucursal_codigo: Number(this.sucursalEmpresa),
          producto_codigo: this.productoSeleccionado.codigo,
        },
        paginaActual: 1,
        cantidadRegistrosPorPagina: -1,
      };

      this.saldoStockService.obtenerStockProducto(inputParamsStock, function ({ mensajes, respuesta }) {
        const ok = respuesta !== null;
        if (!ok) {
          self.messageRendererService.showErrors(mensajes);
          return;
        }

        const registros = respuesta && respuesta.registros ? respuesta.registros : [];
        const match = registros.find((r) => String(r.bodega_codigo) === String(codigoBodega) && String(r.formato_codigo) === String(formatoCodigo));
        const stockDisponibleRaw = match ? Number(match.stock_disponible) : 0;
        const stockDisponible = Number.isFinite(stockDisponibleRaw) ? stockDisponibleRaw : 0;
        const nombreBodega = match && match.bodega_nombre ? match.bodega_nombre : self.getNombreBodegaSeleccionada();

        const saldoInsuficiente = stockDisponible < cantidadSolicitada;
        if (saldoInsuficiente) {
          // Solo alerta: se permite continuar con el proceso.
          if (/(bodega)/i.test(nombreBodega)) {
            self.toastService.warning(`El producto fue agregado, pero la ${nombreBodega} no cuenta con stock suficiente.`);
          } else {
            self.toastService.warning(`El producto fue agregado, pero la bodega ${nombreBodega} no cuenta con stock suficiente.`);
          }
        }

        const notaEsp: any = {};
        notaEsp.mode = self.mode;
        notaEsp.current = self.currentProcess;
        notaEsp.suppressSuccessToast = saldoInsuficiente === true;
        self.onAddProductoRequest.emit(notaEsp);
      });
      return;
    }

    // if (!this.formDetails.valid) {
    //   this.toastrService.warning('Favor complete los datos requeridos');
    //   return
    // }
    // this.onAddProductoRequest.emit({
    //   codigo: this.formDetails.get("codigoProducto").value,
    //   formato: this.formDetails.get("formato").value,
    //   cantidad: Number(this.formDetails.get("cantidad").value),
    //   precio: Number(this.formDetails.get("precioUnitario").value),
    //   descuento: this.formDetails.get("descuento").value ? Number(this.formDetails.get("descuento").value) : 0
    // })

    const notaEsp: any = {};
    notaEsp.mode = this.mode;
    notaEsp.current = this.currentProcess;
    this.onAddProductoRequest.emit(notaEsp);
  }

  validate() {
    this.formValidatorsService.validateAllFormFields(this.formDetails);
    return this.formDetails.valid;
  }

  public getDetalleData() {
    this.log('getdetalleData', this.currentProcess.productDocument);
    return this.currentProcess;
  }

  createPayloadAddProducto() {
    //TRANSFORM DESCUENTO EN FORMATO "," POR "."
    let descproduct = '';
    const descuentoProduct = this.formDetails.get('descuento').value;
    if (descuentoProduct) {
      descproduct = descuentoProduct.replace(',', '.');
    } else {
      descproduct = '0';
    }

    return {
      codigo: this.formDetails.get('codigoProducto').value,
      formato: this.formDetails.get('formato').value,
      cantidad: Number(this.formDetails.get('cantidad').value),
      precio: Number(this.formDetails.get('precioUnitario').value),
      descuento: this.formDetails.get('descuento').value ? Number(descproduct) : 0,
      descripcion_producto: this.productoSeleccionado.descripcion,
      unidad_negocio_codigo: this.productoSeleccionado.unidad_negocio_codigo,
    };
  }

  fillProductos(currentProcess) {
    this.currentProcess = currentProcess;
    this.resetFormDetails();
  }

  eliminarProducto(producto) {
    //CONFIRMACION PARA ELIMINAR PRODUCTO
    this.modalConfirm.showWithInlineConfig('Eliminar pedido', '¿Desea eliminar el pedido seleccionado?', () => {
      this.onDeleteProductoRequest.emit({ producto, current: this.currentProcess, mode: this.mode });
    });
  }

  //HABILITAR LA EDICION DE LOS INPUT
  EditarProducto(pedido) {
    this.inputLinea = pedido.linea;
  }

  //FUNCION QUE PERMITE ELIMINAR Y AGREGAR EL PRODUCTO EN EL FOLIO
  //UNA VEZ QUE PRESIONE EL CHECK
  // ACTUALIZAR LA CANTIDAD DEL PEDIDO
  async ProcesoEditarPedidoCompletado(pedido) {
    const precio = pedido.precio !== null && pedido.precio !== undefined ? Number(pedido.precio) : 0;
    if (precio === 0) {
      this.toastService.error('No está permitido agregar productos con precio 0.');
      return;
    }

    this.inputLinea = 0;

    var currentProcess: any;
    //TRANSFORM DESCUENTO EN FORMATO "," POR "."
    let descproduct = '';
    const descuentoProduct = pedido.descuento.toString();
    if (descuentoProduct) {
      descproduct = descuentoProduct.replace(',', '.');
    } else {
      descproduct = '0';
    }

    //INTERNAMENTE ELIMINAR Y AGREGAR PEDIDO
    const linea = pedido.linea;

    //ELIMINAR PRODUCTO DEL MISMO PROCESO GENERADO:
    currentProcess = await this.notaVentaService.EliminarProductoDelEdit(this.currentProcess.proceso, this.currentProcess.folio, this.currentProcess.cabecera.tipoDocumentoDTE, linea).toPromise();

    //AGREGAR PRODUCTO DEL MISMO PROCESO GENERADO:
    const producto = {
      codigo: pedido.codigo,
      formato: pedido.formato,
      cantidad: pedido.cantidad,
      precio: pedido.precio,
      descuento: Number(descproduct),
      descripcion_producto: pedido.descripcion_producto,
      unidad_negocio_codigo: this.currentProcess.cabecera.unidad_negocio_codigo,
    };

    if (this.currentProcess && this.currentProcess.productDocument) {
      const payload: any = {
        cabecera: this.currentProcess.cabecera,
        folio: this.currentProcess.folio,
        proceso: this.currentProcess.proceso,
        ProductDocument: [producto],
      };

      currentProcess = await this.notaVentaService.AgregarProductoDeNotaEsp(payload).toPromise();
    }

    currentProcess.folio = this.currentProcess.folio;
    this.currentProcess = currentProcess;
    this.toastService.success('Producto editado exitosamente');
  }

  clearContent() {
    this.resetFormDetails();
    this.currentProcess = null;
    this.totalesDocumento = null;
  }

  validateUnidadNegocioCabecera(): boolean {
    if (!this.permiteUnidadNegocio) return true;
    const { unidad_negocio_codigo } = this.cabeceraComponent.getHeaderData();
    return !!unidad_negocio_codigo;
  }

  showMessageSeleccionUnidadNegocio(): void {
    this.toastService.warning('Seleccione unidad de negocio');
  }
}
